<template>
  <div 
    class="approvalRequestPopupWrap" 
    :class="status.approvalRequestPopupViewBln ? 'active' : null " 
    @click="dimmedClickHandler" 
  >
    <div class="contentWrap" ref="contentWrap">
      <h2>외원회 승인 요청</h2>
      <dl class="titleInfo">
        <dt>{{ crntItem?.fieldName }}</dt>
        <dd><span>{{ PROCESS_INFO.processName }}</span></dd>
        <!-- <dd><span class="ellipsis-2">UV/Vis spectrometer를 이용한 Laser ablation 공정의 진행에 따른 금 나노입자의 크기 변화 확인 측정 프로토콜 UV/Vis spectrometer를 이용한 Laser ablation 공정의 진행에 따른 금 나노입자의 크기 변화 확인 측정 프로토콜</span></dd> -->
      </dl>
      <dl class="reasonInfo">
        <dt>신청사유</dt>
        <dd>
          <p class="placeholder" :class="str != '' ? 'hidden' : null ">위원회 승인 담당자가 확인 필요한 수정 사항 및<br />요청 사유를 입력하세요.</p>
          <p 
            ref="requestInput" 
            class="textarea" 
            role="textbox" 
            contenteditable 
            @input="typeHandler"
          ></p>
        </dd>
      </dl>
      <p class="explain">위원회 승인 시 해당 문서가 공개됩니다.</p>
      <div class="btns">
        <btn-link :style="{minWidth: '60px'}" @click="cancelHandler" >취소</btn-link>
        <btn-link color="blue" :style="{minWidth: '80px'}" @click="requestHandler" >요청하기</btn-link>
      </div>
    </div>
  </div>
</template>

<script>
import { commNewMapGetters , commNewMapMutations } from "@processEditor/CommNew";
import BtnLink from '@components/btns/BtnLink.vue'; 
export default {
  components : { 
    BtnLink , 
  } , 
  data () {
    return {
      str : '' , 
    }
  } , 
  computed : {
    ...commNewMapGetters([
      'status' , 
      'PROCESS_INFO' , 
      'crntItem' , 
    ]) , 
  } , 
  mounted () {
  } , 
  methods : {
    ...commNewMapMutations([
      'updateStatus' , 
    ]) , 
    closeHandler () {
      let { updateStatus } = this ; 
      updateStatus({ approvalRequestPopupViewBln : false }) ; 
    } , 
    dimmedClickHandler ( e ) {
      let { closeHandler , $refs : { contentWrap }} = this ; 
      if ( contentWrap.contains( e.target )) return ; 
      closeHandler() ; 
    } , 
    cancelHandler () {
      console.log('a'); 
      this.closeHandler() ; 
    } , 
    requestHandler () {
      // 요청 프로세스 추후 작업 필요 
      this.closeHandler() ; 
    } , 
    typeHandler () {
      let { $refs: { requestInput }} = this ; 
      this.str = requestInput.textContent ; 
    } , 
  } , 
}
</script>

<style lang="scss" scoped>
  .approvalRequestPopupWrap {
    position: fixed; 
    z-index: 10; 
    left: 0; top: 0; width: 100%; height: 100%; 
    display: flex; 
    justify-content: center; align-items: center; 
    visibility: hidden; 
    transition: visibility 0.475s , backdrop-filter 0.475s; 
    backdrop-filter: blur( 0px ); 
    .contentWrap {
      display: flex; 
      flex-direction: column; 
      width: 448px; 
      min-height: 364px; 
      padding: 24px; 
      gap: 24px;
      background-color: $white; 
      border: 1px solid $gray-9; 
      position: relative; 
      opacity: 0; 
      transform: scale( 0 ); 
      transition-property: transform , opacity; 
      transition-duration: 0.475s , 0.475s; 
      transition-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1.125);
      box-shadow: 0px 4px 16px rgba(91, 91, 91, 0.3);

      > h2 {
        font-size: 20px; 
        color: $gray-3; 
        @include text-prt; 
        @include text-prt-b; 
      }

      dl {
        dt , dd {
          @include text-prt; 
          @include text-prt-b; 
          font-size: 14px; 
        }

        &.titleInfo {
          border: 1px solid $gray-9; 
          display: flex; 
          align-items: center; 
          min-height: 37px; 
          position: relative; 
          --size: 116px; 

          &::before {
            content: ''; 
            width: 1px; 
            position: absolute; 
            left: var( --size ); 
            top: 0; 
            bottom: 0; 
            background-color: $gray-9; 
          } 
          dt {
            display: flex; 
            flex-shrink: 0; 
            justify-content: center; 
            align-items: center; 
            width: 116px; 
            height: 100%; 
            text-align: center; 
          }
          dd {
            padding: 10px var( --default-gap ); 
          }
        } // end of .titleInfo 

        &.reasonInfo {
          dt {
            font-size: 16px; 
            height: 27px;
          }

          dd {
            position: relative; 
            height: 80px; 
            border: 1px solid $gray-9; 
            --gap: 8px; 

            .placeholder {
              color: $gray-d; 
              position: absolute; 
              font-size: 14px; 
              left: var( --gap ); top: var( --gap ); 
              line-height: 17px; 
              visibility: visible; 
              @include text-prt-m; 
              z-index: 1;
              &.hidden {
                visibility: hidden; 
              }
            }
            .textarea {
              // padding: var( --gap ); 
              margin: var( --gap ); 
              overflow: hidden; overflow-y: auto; 
              height: calc( 100% - var( --gap ) * 2);
              position: relative; 
              z-index: 2; 
              font-size: 14px; 

              @include text-prt-m; 
              @include scrlbar; 
            }
          }

        } // end of .reasonInfo
      } // end of dl 

      .explain {
        text-align: center; 
        @include text-prt-m; 
        font-size: 16px; 
      }
      .btns { 
        display: flex; 
        gap: 8px; 
        justify-content: center; 
      }
    } // end of .contentWrap

    &.active {
      visibility: visible; 
      // backdrop-filter: blur( 2px ); 
      .contentWrap {
        opacity: 1; 
        transform: scale( 1 ); 
      }
    }
  }
</style>